import { Component } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-character-count',
    templateUrl: './character-count.component.html',
    styleUrls: ['./character-count.component.scss'],
    standalone: false
})
export class CharacterCountComponent {

  textareaValue: string = '';
  characterCount: number = 0;
  backgroundCheckingForm:UntypedFormGroup;

  fields = {
    'backgroundCheckStatus': {
      'class': 'input-normal',
      'messages': ''
    },
    'remarks': {
      'class': 'input-normal',
      'messages': ''
    }
  }
  errorMessages = {
    'backgroundCheckStatus': {
      'required': 'Status is required.'
    },
    'remarks': {
      'required': 'Remarks is required.',
      'maxlength': 'Maximum of 2500 characters allowed.'
    }
  }




  focusOut(id: string) {
    console.log(`Focus out event: ${id}`);
  }
  
}
